export enum SxSDeeplinkState {
    Loading,
    NotFound,
    UnknownError,
}

export interface SxSDeeplinkStore {
    state: SxSDeeplinkState;
}
